import commonFn from '@/commons/commonFunction';
import MSJson from '@/commons/json';
import { MSConstant } from '@/commons/wildcards';
import { MSEnum } from '@/commons/enumeration';
import VueToast from 'vue-toast-notification';
import indexedDB from '@/commons/indexedDB';
import { vfmPlugin } from '@/lib/vueFinalModal';
import { vfpPlugin } from '@/lib/vueFinalPopover';
import VueClickAway from 'vue3-click-away';
import 'vue-toast-notification/dist/theme-sugar.css';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

function looseClone(obj) {
  return MSJson.deserialize(MSJson.serialize(obj));
}

// import { initSocket } from '@/sockets/socket.js';
export function pluginInstall(app) {
  app.config.globalProperties.$ms = app.config.globalProperties.$ms
    ? app.config.globalProperties.$ms
    : {};
  app.config.globalProperties.$ms.commonFn = commonFn;
  app.config.globalProperties.$ms.enum = MSEnum;
  // app.config.globalProperties.$ms.msgBox = messageBox;
  app.config.globalProperties.$ms.msJson = MSJson;
  app.config.globalProperties.$ms.constant = MSConstant;
  // Vue.prototype.$ms.utility = Utility;
  // Vue.prototype.$auth = authService;
  app.config.globalProperties.$ms.indexedDB = indexedDB;
  app.use(vfmPlugin);
  app.use(vfpPlugin);

  app.use(VueToast, window._toastConfig || {});

  app.use(VueClickAway);
  app.use(FloatingVue);
  // initSocket(app);
  //DNThang - 13.04.2020: Thực hiện nhúng vào toàn bộ các element hàm lấy ra VueInstance tránh dùng __Vue__ không chuẩn tắc
  app.mixin({
    mounted() {
      const me = this;
      if (me.$el && !me.$el.getVueInstance) {
        me.$el.getVueInstance = () => {
          return this;
        };
      }
    }
  });
}
